import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import HomeAbout from "../components/global/HomeAbout";
import GlobalCta from "../components/global/GlobalCta";
import ChillerVanIndustries from "../components/chiller-van/ChillerVanIndustries";
import ChillerVanWhyChoose from "../components/chiller-van/ChillerVanWhyChoose";
import ChillerVanFleetTable from "../components/chiller-van/ChillerVanFleetTable";
import ChillerVanPricing from "../components/chiller-van/ChillerVanPricing";
import ChillerVanFaq from "../components/chiller-van/ChillerVanFaq";

import { chillerVanSections } from "../components/chiller-van/chillerVanSections";
import "../components/chiller-van/chiller-van.css";
import "../components/home/home.css";

const ChillerVans = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cv-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cv-fleet-table":
        return (
          <ChillerVanFleetTable
            key={index}
            title={section.title}
            description={section.description}
            image={section.image}
            imageAlt={section.imageAlt}
            columns={section.columns}
            rows={section.rows}
            note={section.note}
          />
        );

      case "cv-industries":
        return (
          <ChillerVanIndustries
            key={index}
            title={section.title}
            description={section.description}
            note={section.note}
            industries={section.industries}
          />
        );

      case "cv-pricing":
        return (
          <ChillerVanPricing
            key={index}
            title={section.title}
            description={section.description}
            tiers={section.tiers}
            tiersNote={section.tiersNote}
            routeTables={section.routeTables}
            zoneTables={section.zoneTables}
            note={section.note}
          />
        );

      case "about":
        return (
          <HomeAbout
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            items={section.items}
            background={section.background}
            actions={section.actions || []}
            imageMaxHeight={section.imageMaxHeight}
          />
        );

      case "cv-why-choose":
        return (
          <ChillerVanWhyChoose
            key={index}
            title={section.title}
            description={section.description}
            reasons={section.reasons}
          />
        );

      case "cv-faq":
        return (
          <ChillerVanFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van for Rent in Dubai — Temperature Controlled Vans | Chiller Fleet Transport</title>
        <meta name="description" content="Chiller Fleet Transport offers chiller van for rent in Dubai for food, dairy & pharmaceutical delivery with same-day availability from our Ras Al Khor base. Book Now." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent" />
        <meta property="og:title" content="Chiller Van for Rent in Dubai — Temperature Controlled Vans | Chiller Fleet Transport" />
        <meta property="og:description" content="Chiller Fleet Transport offers chiller van for rent in Dubai for food, dairy & pharmaceutical delivery with same-day availability from our Ras Al Khor base. Book Now." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent" />
        <meta name="twitter:title" content="Chiller Van for Rent in Dubai — Temperature Controlled Vans | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Chiller Fleet Transport offers chiller van for rent in Dubai for food, dairy & pharmaceutical delivery with same-day availability from our Ras Al Khor base. Book Now." />
      </Helmet>

      {chillerVanSections.map(renderSection)}
    </>
  );
};

export default ChillerVans;
